























































































import {
  defineComponent,
  onMounted,
  ref,
  watch,
  reactive,
  computed,
} from "@vue/composition-api";
import { useMachine } from "@xstate/vue";
import { AxiosResponse } from "axios";

import {
  ArticleRegistrationApi,
  GetArticleRegistrationTableRequest,
  VueTableResponseOfArticleRegistrationDisapprovedTableDto,
  ArticleRegistrationApprovedTableDto,
  ProjectDto,
} from "@/api";
import ExportComponent from "@/components/export/ExportComponent.vue";
import { DataTableHeader, DataOptions } from "vuetify";
import Store from "@/store";
import {
  toLocalDateStringShort,
  toLocalDateTimeStringShort,
} from "@/util/date";
import i18n from "@/i18n";
import requestListMachine from "./RequestListMachine";

export default defineComponent({
  components: { ExportComponent },
  setup() {
    const { state, service } = useMachine(requestListMachine);
    const api = new ArticleRegistrationApi();

    const search = ref("");
    const currentPage = ref(0);
    const isDownloading = ref(false);
    const exportData = ref<AxiosResponse<string>>();

    const response: VueTableResponseOfArticleRegistrationDisapprovedTableDto = reactive(
      {
        items: [],
        total: 0,
      }
    );

    const selectedProject = computed<ProjectDto | null>(
      () => Store.getters["User/getSelectedProject"]
    );

    let options: DataOptions = reactive({
      page: 1,
      itemsPerPage: 10,
      sortBy: ["startDate"],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
    });

    const headers: DataTableHeader[] = [
      {
        text: i18n.t("request.table.start-date").toString(),
        value: "startDate",
      },
      {
        text: i18n.t("request.table.name").toString(),
        value: "lastName",
      },
      {
        text: i18n.t("request.table.first-name").toString(),
        value: "firstName",
      },
      {
        text: i18n.t("request.table.birth-date").toString(),
        value: "birthDate",
      },
      {
        text: i18n.t("request.table.employee-number").toString(),
        value: "employeeNr",
      },
      {
        text: i18n.t("request.table.disapproved-by").toString(),
        value: "disapprovedByEmailAddress",
      },
      {
        text: i18n.t("request.table.date").toString(),
        value: "disapprovedDate",
      },
      {
        text: "",
        value: "actions",
      },
    ];

    async function fetchResults() {
      if (!selectedProject.value?.projectId) return;

      try {
        const request: GetArticleRegistrationTableRequest = {
          sortBy: options.sortBy,
          descending: options.sortDesc,
          page: options.page,
          rowsPerPage: options.itemsPerPage,
          search: search.value,
          projectId: Store.getters["User/getSelectedProject"].projectId,
        };
        const {
          data,
        } = await api.articleRegistrationGetArticleRegistrationDisapprovedTable(
          request
        );

        const { total, items } = data;

        response.items = items;
        response.total = total;

        service.send("RESOLVE");
      } catch (e) {
        service.send("REJECT");
      }
    }

    function getLastName(item: ArticleRegistrationApprovedTableDto) {
      if (item.middleName) {
        return `${item.lastName}, ${item.middleName}`;
      }
      return item.lastName;
    }

    function updateOptions(opts: DataOptions) {
      options = opts;
      service.send("RELOAD");
    }

    function onExport() {
      if (!selectedProject.value?.projectId) return;

      isDownloading.value = true;

      api
        .articleRegistrationExportArticleRegistrationDisapprovedToExcel(
          { projectId: selectedProject.value?.projectId },
          {
            responseType: "arraybuffer",
          }
        )
        .then((data) => {
          isDownloading.value = false;
          exportData.value = data;
        })
        .catch(() => {
          isDownloading.value = false;
        });
    }

    onMounted(async () => {
      service.subscribe((s) => {
        if (s.matches("loading")) {
          fetchResults();
        }
      });
    });

    watch(
      () => search.value,
      () => {
        currentPage.value = 1;
        fetchResults();
      }
    );

    watch(selectedProject, () => {
      fetchResults();
    });

    return {
      getLastName,
      headers,
      options,
      search,
      currentPage,
      state,
      response,
      toLocalDateStringShort,
      toLocalDateTimeStringShort,
      updateOptions,
      isDownloading,
      exportData,
      onExport,
    };
  },
});
